import React, {useEffect, useState} from "react";
import "./ModalStyle.css";

function Modal({ isOpen,children, title, onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
    } else {
      setTimeout(() => setVisible(false), 300); // attendre que l'animation se termine
    }
  }, [isOpen]);


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);
  if (!isOpen && !visible) return null;
 
  

  return (
    <div className={`modal-overlay ${isOpen ? "fade-in" : "fade-out"}`} onClick={onClose}>
      <div className={`modal-content ${isOpen ? "zoom-in" : "zoom-out"}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="title">{title}</h2>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
